module.exports = __webpack_public_path__ + "img/art7.0120dc74.png";